/* PP (12 Sep 2026): Prestige's product-sticky-bar reveals itself once the form named in its `form`
   attribute has scrolled off the top. The theme points it at the main product form, which on this
   store sits below the hero, so the bar arrived late. Point it at the hero form instead. The form's
   id is read with getAttribute because the form contains <input name="id">, which shadows form.id.
   Runs before theme.js (not deferred) so the attribute is in place before the element upgrades.

   13 Sep 2026 (reviewer #5): with the hero form as the trigger, the bar also showed while the buy
   box's own ADD TO CART was on screen, two identical CTAs at once. The bar now carries data-pp-hide
   whenever that button is at least a fifth visible; assets/pp-review-fixes.css hides it on that
   attribute, so Prestige's own show/hide logic is left untouched. */
(function () {
  function patch(bar) {
    if (!bar || bar.hasAttribute('data-pp-patched')) return;
    var heroForm = document.querySelector('form.pp-hero__form');
    var id = heroForm && heroForm.getAttribute('id');
    if (id) bar.setAttribute('form', id);
    bar.setAttribute('data-pp-patched', '');
  }
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('product-sticky-bar')) patch(node);
        else if (node.querySelector) patch(node.querySelector('product-sticky-bar'));
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('product-sticky-bar');
    var button = document.querySelector('.product-info form[action*="/cart/add"] button[type="submit"]');
    if (!bar || !button || !('IntersectionObserver' in window)) return;
    var hideForButton = false;
    var hideForForm = false;
    function apply() {
      if (hideForButton || hideForForm) bar.setAttribute('data-pp-hide', '');
      else bar.removeAttribute('data-pp-hide');
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { hideForButton = entry.isIntersecting; });
      apply();
    }, { threshold: 0.2 }).observe(button);

    /* Products whose hero has no form (multi-variant, e.g. the gift card, whose hero says "Choose options")
       keep Prestige's default trigger, the main product form: never show the bar until that form has scrolled
       past. Checked on scroll rather than with an IntersectionObserver because a jump from the bottom of the
       page straight to the top (Home key, anchor, scroll-to-top) moves the form from "below the viewport" to
       "above the viewport" without ever intersecting, so no observer callback fires (reviewer #7). */
    var heroForm = document.querySelector('form.pp-hero__form');
    var mainForm = document.forms[bar.getAttribute('form')];
    if (!heroForm && mainForm) {
      var ticking = false;
      var check = function () {
        ticking = false;
        hideForForm = mainForm.getBoundingClientRect().bottom > 0;
        apply();
      };
      check();
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(check);
      }, { passive: true });
      window.addEventListener('resize', check);
    }
  });
})();